module.exports = __webpack_public_path__ + "img/CC2024.cd173633.png";